export const categories = [
  {
    slug: "chuanda-gonglue",
    name: "穿搭攻略",
    description: "从基础到进阶，全方位穿搭技巧与灵感分享",
    icon: "ri-t-shirt-line",
    image: "https://readdy.ai/api/search-image?query=Elegant%20fashion%20woman%20wearing%20chic%20outfit%20walking%20on%20city%20street%2C%20warm%20golden%20hour%20lighting%2C%20luxurious%20fabric%20texture%2C%20magazine%20editorial%20photography%2C%20soft%20cream%20background%20tone%2C%20sophisticated%20style%2C%20clean%20composition&width=800&height=600&seq=cat-chuanda&orientation=landscape",
  },
  {
    slug: "peishi-dapei",
    name: "配饰搭配",
    description: "包包、首饰、丝巾等配饰的精选搭配法则",
    icon: "ri-vip-diamond-line",
    image: "https://readdy.ai/api/search-image?query=Luxury%20accessories%20flat%20lay%20with%20gold%20jewelry%20silk%20scarf%20designer%20handbag%20and%20sunglasses%2C%20warm%20beige%20background%2C%20elegant%20composition%2C%20soft%20natural%20lighting%2C%20editorial%20product%20photography%2C%20refined%20aesthetic&width=800&height=600&seq=cat-peishi&orientation=landscape",
  },
  {
    slug: "zhuangrong-jiaocheng",
    name: "妆容教程",
    description: "从日常妆到晚宴妆，精致妆容分步教学",
    icon: "ri-brush-line",
    image: "https://readdy.ai/api/search-image?query=Elegant%20makeup%20products%20on%20a%20vanity%20table%20with%20soft%20warm%20lighting%2C%20luxury%20cosmetics%20brushes%20and%20palettes%2C%20cream%20and%20rose%20gold%20color%20scheme%2C%20beauty%20editorial%20style%2C%20refined%20feminine%20aesthetic%2C%20clean%20composition&width=800&height=600&seq=cat-zhuangrong&orientation=landscape",
  },
  {
    slug: "yitai-xiuyang",
    name: "仪态修养",
    description: "优雅举止与气质提升的修炼之道",
    icon: "ri-user-star-line",
    image: "https://readdy.ai/api/search-image?query=Elegant%20woman%20with%20graceful%20posture%20standing%20in%20luxurious%20interior%2C%20soft%20warm%20lighting%2C%20classic%20sophisticated%20style%2C%20refined%20feminine%20elegance%2C%20editorial%20portrait%20photography%2C%20cream%20tone%20background&width=800&height=600&seq=cat-yitai&orientation=landscape",
  },
  {
    slug: "changhe-chuanda",
    name: "场合穿搭",
    description: "约会、职场、派对等不同场合的专属搭配方案",
    icon: "ri-calendar-event-line",
    image: "https://readdy.ai/api/search-image?query=Three%20stylish%20women%20in%20different%20elegant%20outfits%20for%20various%20occasions%2C%20warm%20golden%20lighting%2C%20luxurious%20urban%20setting%2C%20magazine%20editorial%20photography%2C%20sophisticated%20style%2C%20soft%20neutral%20background&width=800&height=600&seq=cat-changhe&orientation=landscape",
  },
];

export const categoryMap: Record<string, typeof categories[0]> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});